import React from 'react';
export function HeroSection() {
  return <section className="relative bg-red-700" data-id="element-143">
      <div className="absolute inset-0 bg-gradient-to-r from-red-800 to-red-600 opacity-90" data-id="element-144"></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 relative z-10" data-id="element-145">
        <div className="max-w-4xl mx-auto text-center" data-id="element-146">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6" data-id="element-147">
            Trusted Fire Safety Experts Since 1980
          </h1>
          <p className="text-xl text-white opacity-90 mb-8" data-id="element-148">
            Since 1980, the Fire Safety Displays Company has been providing "You
            are Here" evacuation displays for all different types of companies
            to meet OSHA, International Building Code, joint commission, fire
            department and other regulatory requirements.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-149">
            <a href="#system" className="px-8 py-3 bg-white text-red-700 font-medium rounded-md hover:bg-gray-100 transition duration-300" data-id="element-150">
              Learn About "The System"
            </a>
            <a href="#contact" className="px-8 py-3 bg-transparent border-2 border-white text-white font-medium rounded-md hover:bg-white/10 transition duration-300" data-id="element-151">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>;
}